import React, { useEffect, useState } from "react";
import "./index.css";
import logo from "../../assets/images/png/creta.png";
export default function Home() {
  return (
    <>
      <div
        className="bgHome"
        style={{
          backgroundImage: `url(${logo})`,
        }}
      >
        {/* Conteúdo dentro do div */}
      </div>
    </>
  );
}
